import { gql } from "@apollo/client";

export const DELETE_NEWS = gql`
  mutation removeAd($adId: Int!) {
    removeAd(adId: $adId) {
      id
    }
  }
`;
